import React, { ReactNode, useState } from "react";
import Styles from "./EditToolController.module.scss";

interface EditToolControllerProps {
    id: string;
    label: string;
    icon: ReactNode;
    minValue: number;
    maxValue: number;
    defaultValue: number;
    onValueChange: (value: number) => void;
}

const EditToolController = ({ id,label, icon, minValue, maxValue, defaultValue, onValueChange }: EditToolControllerProps) => {

    const handleValueChange = (e: any) => {
        onValueChange(e.target.value);
    }

    return (
        <div className={Styles.container} >
            <div className={Styles.icon_container}>
                {icon}
            </div>
            <div className={Styles.text_label}>
                {label}
            </div>
            {/* <div className={Styles.input_text_label}>
                {minValue}
            </div> */}
            <div className={Styles.slider_container}>
                <input
                    id={Styles[id]}
                    type="range"
                    min={minValue}
                    max={maxValue}
                    onChange={(e) => { handleValueChange(e) }}
                    value={defaultValue}
                />
            </div>
            {/* <div className={Styles.input_text_label}>
                {maxValue}
            </div> */}
        </div>
    )
}

export default EditToolController
